import { useMemo, Fragment, useEffect, useState } from 'react';
import { Grid, Box } from '@material-ui/core';
import { profileService } from 'shared/services/profileService';
import { IMyLinkTalentInfo } from 'pages/MyLinks/types';
import { ProfileListSkeletonMulti } from 'pages/MyLinks/Skeletons/ProfileListSkeleton/ProfileListSkeleton';
import ProfileListItemSmall from './ProfileListItemSmall/ProfileListItemSmall';

const { getProfileLinks } = profileService();
const ProfileList = ({ talentInfo }: { talentInfo: IMyLinkTalentInfo }) => {
  const { data, isLoading } = getProfileLinks();
  const [selectedPrimary, setSelectedPrimary] = useState<string | null>(null);
  const linkProfiles = useMemo(() => (isLoading ? [] : data?.data?.profiles), [data, isLoading]);

  useEffect(() => {
    if (linkProfiles) {
      const findSelected = linkProfiles.find((link) => link?.primary_link);
      setSelectedPrimary(findSelected?.id || null);
    }
  }, [linkProfiles]);

  const content = useMemo(
    () =>
      linkProfiles ? (
        linkProfiles?.map((item) => (
          <Grid item xs={12} key={item?.id}>
            <ProfileListItemSmall
              profileLink={item}
              selectedPrimary={selectedPrimary}
              setSelectedPrimary={setSelectedPrimary}
              talentInfo={talentInfo}
            />
          </Grid>
        ))
      ) : (
        <Fragment />
      ),
    [linkProfiles, selectedPrimary, talentInfo],
  );

  // useEffect(() => {
  //   if (linkProfiles) {
  //     setLocalProfiles(linkProfiles);
  //   }
  // }, [linkProfiles]);

  // const updateLocalProfile = (id: string, profile: Partial<IProfileLink>) => {
  //   setLocalProfiles((prev) =>
  //     prev.map((p) => {
  //       if (profile.id === id) {
  //         return { ...p, profile };
  //       }
  //       return p;
  //     }),
  //   );
  // };

  if (isLoading) return <ProfileListSkeletonMulti />;

  return (
    <Box marginTop={'10px'}>
      <Grid container spacing={2}>
        {content}
      </Grid>
    </Box>
  );
};

export default ProfileList;
